export interface ToggleProps {
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
  disabled?: boolean;
  label?: string;
  'data-testid'?: string;
}

export function Toggle({ checked, onCheckedChange, disabled = false, label, 'data-testid': testId }: ToggleProps) {
  const id = label ? `toggle-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined;

  return (
    <label
      className={[
        'inline-flex items-center gap-2 select-none',
        disabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer',
      ].join(' ')}
    >
      <button
        id={id}
        role="switch"
        type="button"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onCheckedChange(!checked)}
        data-testid={testId ?? 'settings-switch'}
        className={[
          'relative inline-flex h-6 w-11 shrink-0 rounded-full',
          'transition-colors duration-motion-default ease-cursor-out',
          checked ? 'bg-action' : 'bg-border',
        ].join(' ')}
      >
        <span
          className={[
            'pointer-events-none inline-block h-5 w-5 rounded-full bg-foreground',
            'transition-transform duration-motion-default ease-cursor-out',
            'translate-y-0.5',
            checked ? 'translate-x-5' : 'translate-x-0.5',
          ].join(' ')}
        />
      </button>
      {label && <span className="text-body text-foreground">{label}</span>}
    </label>
  );
}
